module.exports = __webpack_public_path__ + "static/img/index-banner_player.d2a2c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-banner_player.png
// module id = VwHw
// module chunks = 0